import React from 'react'
import Image from 'react-bootstrap/Image'

/* Styles and markup extracted from Certificate.js — Certificate of Achievement printable block */
const certificateAchievementPrintStyles = `
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }

          .rbt-menu {
            z-index: 1051 !important;
          }
        
    /* Watermark styles */
      .certificate-border {
        position: relative;
        background-color: white;
        overflow: hidden;
      }

.watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  opacity: 0.8; /* adjust as needed */
  z-index: 0;
  pointer-events: none;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.watermark-logo-wrapper img {
  width: 200%;       /* increase width only */
  height: auto;      /* keep height proportional */
  max-width: none;   /* prevent automatic limiting */
}


      /* Content stays above watermark */
      .certificate-content > * {
        position: relative;
        z-index: 1;
        margin-top: -2rem;
      }

          @media print {
          
            /* Hide filter section and non-printable controls */
            .no-print {
              display: none !important;
              visibility: hidden !important;
            }
          
            /* Hide sidebar and navigation completely */
            aside, nav, .sidebar, [class*="sidebar"], [class*="Sidebar"], 
            [class*="Sidenavbar"], [class*="sidenavbar"] {
              display: none !important;
              visibility: hidden !important;
              width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
            }

            /* Reset ALL container divs that might have marginLeft or padding */
            div[style*="marginLeft"], 
            div[style*="margin-left"], 
            div[style*="paddingLeft"],
            div[style*="padding-left"],
            .container-fluid,
            .App > div,
            .App > div > div {
              margin-left: 0 !important;
              margin-right: 0 !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              left: 0 !important;
              transform: none !important;
            }

           
            /* Hide all elements by default */
            body * {
              // visibility: hidden;
            }

            .title-underline {
              display: block !important;
              height: 3px !important;
              background-color: #f1c40f !important;
              margin: 10px auto !important;
              border-bottom: 2px solid #f1c40f;
            }

            /* Show only certificate content */
            .certificate-printable, .certificate-printable * {
              visibility: visible;
            }
            
            .certificate-printable {
              position: absolute !important;
              left: 0 !important;
              top: 0 !important;
              margin-bottom: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              margin-top: 0 !important;
              padding: 0 !important;
              transform: none !important;
            }

            /* Ensure certificate wrapper maintains centered layout with max-width */
            .certificate-wrapper {
              width: 100% !important;
              max-width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              margin: 0 auto !important;
              padding: 0 !important;
            }

            .certificate-border {
              width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              box-sizing: border-box !important;
            }

            html, body {
              width: 100% !important;
              height: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        //         .watermark-logo-wrapper {
        //   opacity: 13 !important;
        //   width: 100% !important;
        // }
        
//         @media print {
//   .certificate-border {
//     border: 25px solid #4a6da7 !important;
//     background-color: white !important;
//     box-shadow: none !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//     color-adjust: exact;
//   }

//   /* Ensure the wrapper is visible */
//   .certificate-wrapper {
//     visibility: visible !important;
//     position: relative !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//   }
// }


            @page {
              size: A4 portrait;
              margin: 0mm;
            }
          }
          .certificate-wrapper {
            max-width: 1200px;
            margin: 0 auto;
            position: relative;
            width: 100%;
          }
          .certificate-border {
            background-color: white;
            border: 15px solid #4a6da7;
            position: relative;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
            print-color-adjust: exact;
            width: 100%;
            max-width: 100%;
          }
          
          /* Prevent certificate from responding to sidebar changes in UI view */
          .certificate-printable {
            position: relative;
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            isolation: isolate;
            left: auto !important;
            right: auto !important;
          }
          
          /* Ensure certificate elements maintain fixed positions and don't expand/collapse */
          .certificate-content {
            position: relative;
            width: 100%;
          }
          
          /* Prevent elements with inline marginLeft from being affected by parent */
          .certificate-content > div[style*="marginLeft"],
          .certificate-content > div[style*="margin-left"] {
            position: relative !important;
          }
          
          /* Prevent certificate from responding to sidebar changes in UI */
          .certificate-printable {
            position: relative;
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            isolation: isolate;
            left: auto !important;
            right: auto !important;
          }
          .corner {
            position: absolute;
            width: 50px;
            height: 50px;
          }
          .corner-tl {
            top: -3px;
            left: -5px;
          }
          .corner-tr {
            top: -5px;
            right: -5px;
            transform: rotate(90deg);
          }
          .corner-bl {
            bottom: -5px;
            left: -5px;
            transform: rotate(270deg);
          }
          .corner-br {
            bottom: -5px;
            right: -5px;
            transform: rotate(180deg);
          }
          .certificate-title {
            font-family: 'Times New Roman', serif;
            font-weight: bold;
            color: #2c3e50;
            font-size: 2.3rem;
            position: relative;
            display: inline-block;
          }
          .title-underline {
            width: 100px;
            height: 3px;
            background-color: #f1c40f;
            margin: 10px auto;
          }
          .student-name {
            // font-family: 'Brush Script MT', cursive;
            font-family: 'Lora', serif;
            font-weight: bold;
            font-size: 2.5rem;
            color: #2c3e50;
            margin: 1rem 0;
            position: relative;
            display: inline-block;
          }

           .student-name::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
            background: linear-gradient(90deg, transparent, #f1c40f, transparent);
    display: block;
    visibility: visible;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  
          .certificate-description {
            max-width: 700px;
            font-size: 1.6rem;
            line-height: 1;
          }
          .detail-item {
            // margin-bottom: 0.5rem;
          }
          .detail-label {
            font-weight: bold;
            margin-right: 0.5rem;
          }
          .signature-line {
            // width: 200px;
            // height: 1px;
            // background-color: #333;
            // margin: 0 auto;

              border-top: 1px solid #000;
  width: 150px;
  margin: 0 auto 8px auto;
          }
          .signature-name {
            font-weight: bold;
            margin-top: 10px;
          }

          
  
 
            
          .institution-logo img {
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
          }
          .print-button {
            background-color: #2c3e50;
            border: none;
            padding: 10px 25px;
            font-weight: bold;
          }
          .print-button:hover {
            background-color: #1a252f;
          }
          @media (max-width: 768px) {
            .certificate-title {
              font-size: 2rem;
            }

              
            .student-name {
              // font-size: 2.5rem;
            }
            .certificate-border {
              border-width: 10px;
            }
            .corner {
              width: 40px;
              height: 40px;
            }
          }
          @media (max-width: 576px) {
            .certificate-title {
              font-size: 1.8rem;
            }
            .student-name {
              font-size: 2rem;
            }
            .certificate-description {
              font-size: 1rem;
            }
            .signature-line {
              width: 150px;
            }
          }
 
       @media print {
  // .certificate-content img,
  // .certificate-content svg,
  // .certificate-content text {
  //   visibility: visible !important;
  // }

        // .certificate-border {
        //     background-color: white;
        //     border: 17px solid #4a6da7;
        // }

 .certificate-content svg {
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width:660px !important;
    margin-top:-4rem !important;
  }
    .certificate-content .img-tta{
          margin-left:0rem !important;
          margin-top:0rem !important;
          border-radius: 50% !important;
          object-fit: cover !important;
    }
 
           .certificate-content .img-style{
          // margin-right:2rem !important;
          margin-top:-2rem !important;
    }
    .certificate-content text{
    font-size:21px !important;
    margin-bottom:13rem !important;
    }
    
    /* Fix SVG text element (institute name) positioning in print view */
    .certificate-content svg text {
      font-size: 21px !important;
      font-weight: bold !important;
      fill: #2c3e50 !important;
    }
    
    /* Ensure the div containing SVG maintains proper positioning in print view */
    .certificate-content > div[style*="marginTop"][style*="-400"] {
      position: relative !important;
      margin-top: -400px !important;
      margin-left: 0 !important;
      width: 100% !important;
      height: 200px !important;
      display: flex !important;
      justify-content: center !important;
    }
    
    /* Ensure SVG maintains proper size and positioning */
    .certificate-content > div[style*="marginTop"][style*="-400"] svg {
      width: 900px !important;
      height: 1200px !important;
      viewBox: 0 0 430 150 !important;
    }
}
@media print {
  .gof-nct {
    background-color: #4a6da7 !important;
    color: white !important;
    font-style: italic;
    font-size: 18px !important;
    border-radius: 2px !important;
    width: 10% !important;
    // max-width: 70% !important;
    // min-width: auto !important;
    margin-top:5.3rem !important;
    // padding: 2px !important;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  
  /* Override inline styles for print view */
  .certificate-content .gof-nct[style*="width"] {
    // width: 70% !important;
    margin-left: 6.5rem !important;
    max-width: 70% !important;
  }
  
  .gof-nct p {
    // padding: 5px !important;
    // margin: 0 !important;
  }
  
  /* Fix SVG text element (institute name) positioning in print view */
  .certificate-content svg {
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width:650px !important;
  }
  
  .certificate-content svg text {
    // font-size: 19px !important;
    // font-weight: bold !important;
    // fill: #2c3e50 !important;
  }
  
  .certificate-content > div[style*="marginTop"][style*="-400"] {
    // margin-top: -400px !important;
    // margin-left: -40px !important;
    // width: 100% !important;
    // height: 200px !important;
  }

.logo-box{
margin-top:14rem !important;
}
      .img-nct {
      margin-top:1rem !important;
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
              height: 90px !important;  /* smaller in print */
            width: 90px !important;
          }
      .gvt{
      font-size:8px !important;
      }
}

@media print {
  .row-signatures {
    margin-bottom: -2rem !important;
  }

  /* Fix bottom positioning when grade exists */
  .row-signatures.has-grade {
    margin-top: 4.7rem !important;
    // margin-bottom: 10px !important;
    // position: relative !important;
  }

  /* Keep same style when grade doesn't exist */
  .row-signatures.no-grade {
    margin-top: 8.6rem !important;
    // margin-bottom: -2rem !important;
  }
}

@media print {
  /* Fill full A4 page — remove bottom gap */
  html, body, #root, .App {
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
  }

  .certificate-printable,
  .certificate-wrapper,
  .certificate-border {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .certificate-printable {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }

  /* Increase watermark height in print view */
  .watermark-logo-wrapper {
    height: 120% !important;
  }
  
  .watermark-logo-wrapper img {
    height: 120% !important;
  }
}


`

/** Sample data for Manage Templates preview — mirrors Certificate.js API shape */
export const buildCertificateAchievementPreviewData = (instituteName) => {
  const end = new Date()
  const start = new Date()
  start.setFullYear(start.getFullYear() - 1)
  return {
    institute: { institute_name: instituteName || 'Institute Name' },
    student: {
      name: 'Student Name',
      father_name: 'Father Name',
      mother_name: 'Mother Name',
      admission_number: 'ADM-0001',
      student_image: '/studentprofile.jpg',
    },
    course: {
      course_name: 'Course Name',
      start_date: start.toISOString(),
      end_date: end.toISOString(),
    },
    certificate: {
      certificate_number: '2026-C71-S421-0013',
      issue_date: end.toLocaleDateString('en-GB'),
      grade: 'A+',
    },
  }
}

/**
 * @param {{ logo?: string, certificateData: object }} props — same `certificateData` shape as Certificate.js when certificate is generated
 */
const CertificateAchievementPrint = ({ logo, certificateData }) => {
  const courseStart = certificateData?.course?.start_date
  const courseEnd = certificateData?.course?.end_date
  const duringText =
    courseStart && courseEnd
      ? `${new Date(courseStart).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })} - ${new Date(courseEnd).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })}`
      : '\u00A0'

  return (
    <>
      <style>{certificateAchievementPrintStyles}</style>
      <div
        className="certificate-printable"
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          left: 'auto',
          right: 'auto',
          transform: 'none',
        }}
      >
        <div className="certificate-wrapper mt-4">
          <div className="certificate-border ">
            <div className="watermark-logo-wrapper">
              <img src="/certWatermark.jpg" alt="Watermark Logo" className="watermark-logo" />
            </div>
            <div className="corner corner-tl" />
            <div className="corner corner-tr" />
            <div className="corner corner-bl" />
            <div className="corner corner-br" />

            <div className="certificate-content p-4 p-md-5">
              <div className="d-flex justify-content-between align-items-center">
                <img
                  src={logo}
                  alt="Institution Logo"
                  className="img-tta"
                  style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover' }}
                />
                <div className="text-center">
                  <img
                    src="/nct_logo2.png"
                    alt="NCT Logo"
                    className="img-nct"
                    style={{ width: '100px', height: '100px' }}
                  />
                  <div className="gvt" style={{ fontSize: '10px', fontWeight: 'bold', marginTop: '4px' }}>
                    GOVERNMENT OF NCT OF DELHI
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'relative',
                  marginTop: -400,
                  marginLeft: 0,
                  width: '100%',
                  height: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <svg
                  width="900"
                  height="1200"
                  viewBox="0 0 500 160"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'block', margin: '0 auto' }}
                >
                  <defs>
                    <path
                      id="curve"
                      d="M 25 135 A 240 270 0 0 1 475 135"
                      fill="transparent"
                    />
                  </defs>
                  <text fill="#2c3e50" fontSize="21px" fontWeight="bold">
                    <textPath href="#curve" startOffset="50%" textAnchor="middle">
                      {certificateData?.institute?.institute_name?.toUpperCase()}
                    </textPath>
                  </text>
                </svg>
              </div>

              <div
                style={{
                  marginTop: 250,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginBottom: '-2rem',
                }}
                className="logo-box"
              >
                <img src="/education-logo3.png" alt="Education Logo" style={{ width: '100px' }} />
              </div>

              <div
                className="gof-nct"
                style={{
                  backgroundColor: '#4a6da7',
                  color: 'white',
                  width: '50%',
                  fontSize: '20px',
                  borderRadius: '2px',
                  marginTop: 85,
                  marginLeft: 280,
                }}
              >
                <p style={{ padding: 5 }}>Project Plan Conducted By Government of NCT of Delhi</p>
              </div>
              <div className="text-center mb-3 pt-4 powered-by-footer" style={{ marginTop: -40 }}>
                <small className="fw-bold powered" style={{ fontStyle: 'italic', fontSize: '14px', color: '#' }}>
                  Tera Tujko Arpan (ISO 9001 : 2015)
                </small>
                <p
                  className="fw-bold powered"
                  style={{ fontSize: '14px', color: '#', letterSpacing: '1px', fontStyle: 'italic' }}
                >
                  UDYAM-DL-10-0079981
                </p>
              </div>
              <div className="text-center" style={{ marginTop: -10 }}>
                <h2 className="certificate-title" style={{}}>
                  Certificate of Achievement
                </h2>
                <div className="title-underline mx-auto" />
                <p style={{ fontWeight: '600' }}>This Certificate is Awarded To</p>
              </div>
              <div
                className="certificate-header"
                style={{
                  marginBottom: '60px',
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    textAlign: 'center',
                    width: 'max-content',
                  }}
                >
                  <h2
                    className="student-name"
                    style={{ margin: 0, marginTop: '2rem', fontSize: '32px', fontWeight: 'bold' }}
                  >
                    {certificateData?.student?.name}
                  </h2>
                </div>

                <div style={{ flex: 1, textAlign: 'right' }}>
                  <Image
                    className="img-style"
                    crossOrigin="anonymous"
                    src={certificateData?.student?.student_image || '/studentprofile.jpg'}
                    alt="Student"
                    style={{
                      width: '70px',
                      height: '70px',
                      border: '1px solid black',
                      background: 'white',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              </div>

              <div style={{ flex: 1, textAlign: 'left', fontWeight: 'bold' }}>
                <p style={{ marginTop: '-2rem', marginBottom: '10px', fontSize: '14px' }}>
                  Certificate Number: <strong>{certificateData?.certificate?.certificate_number}</strong>
                </p>
              </div>
              <div className="certificate-details text-start" style={{ fontWeight: 'bold', marginTop: '12px' }}>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  This certificate is awarded to
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.student?.name || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  Son/Daughter of{' '}(Father)
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.student?.father_name || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  and{' '}(Mother)
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.student?.mother_name || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  Admission number{' '}
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.student?.admission_number || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  Course on{' '}
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.course?.course_name || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  during{' '}
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                      marginTop: '0px',
                    }}
                  >
                    {duringText}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  The candidate is sponsored by{' '}
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {certificateData?.institute?.institute_name || '\u00A0'}
                  </span>
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  Candidate has been awarded{' '}
                  <span
                    style={{
                      flex: 1,
                      borderBottom: '1px solid black',
                      marginLeft: '8px',
                      fontWeight: 'bold',
                      justifyContent: 'center',
                      display: 'flex',
                      marginTop: '18px',
                    }}
                  >
                    {certificateData?.certificate?.grade || '\u00A0'}
                  </span>{' '}
                  Grade
                </p>
              </div>

              <div
                className={`row signatures row-signatures ${certificateData?.certificate?.grade ? 'has-grade' : 'no-grade'}`}
                style={{
                  marginTop: '74px',
                  marginBottom: '-1.8rem',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  textAlign: 'center',
                  fontWeight: 'bold',
                }}
              >
                <div style={{ flex: 2, textAlign: 'left' }}>
                  <p className="mb-0">Date of issue:</p>
                  <p className="fw-bold">{certificateData?.certificate?.issue_date}</p>
                </div>

                <div style={{ flex: 7, textAlign: 'center' }}>
                  <div className="signature-line mb-1" />
                  <p className="mb-0">Instructor</p>
                  <p className="signature-name">Authorized Signatory</p>
                </div>

                <div style={{ flex: 2, textAlign: 'center' }}>
                  <div className="signature-line mb-1" />
                  <p className="mb-0">Director</p>
                  <p className="signature-name">Authorized Signatory</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CertificateAchievementPrint
